import React from "react";

// Brand logo: B-in-circle image on the left, "BLANKTJERN / COACHING" wordmark on the right.
// Variant: "dark" = black ink on light bg, "light" = white ink on dark bg.
// Size: "md" (navbar default) or "sm" (footer).
// All sizing / colors handled via CSS classes so we can apply mobile media queries.
export default function Logo({ variant = "dark", size = "md" }) {
  const isLight = variant === "light";
  const cls = `bt-logo bt-logo--${variant} bt-logo--${size}`;
  return (
    <div className={cls}>
      <img
        src={isLight ? "/images/b-logo-light.png" : "/images/b-logo-dark.png"}
        alt=""
        className="bt-logo__mark"
        width="42"
        height="42"
      />
      <div className="bt-logo__wordmark">
        <div className="bt-logo__title">BLANKTJERN</div>
        <div className="bt-logo__sub">COACHING</div>
      </div>
    </div>
  );
}
